import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

interface UploadProgressBarProps {
  progress: number; // 0-100
  fileName?: string;
}

export const UploadProgressBar: React.FC<UploadProgressBarProps> = ({
  progress,
  fileName
}) => {
  return (
    <View style={styles.container}>
      {fileName && (
        <Text style={styles.fileName} numberOfLines={1}>
          Uploading: {fileName}
        </Text>
      )}
      <View style={styles.progressBarContainer}>
        <View style={styles.progressBarBackground}>
          <View
            style={[
              styles.progressBarFill,
              { width: `${Math.min(100, Math.max(0, progress))}%` }
            ]}
          />
        </View>
        <Text style={styles.progressText}>
          {Math.round(progress)}%
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    marginVertical: 8,
  },
  fileName: {
    fontSize: 14,
    color: '#333',
    marginBottom: 8,
    fontWeight: '500',
  },
  progressBarContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  progressBarBackground: {
    flex: 1,
    height: 24,
    backgroundColor: '#e0e0e0',
    borderRadius: 12,
    overflow: 'hidden',
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: '#FF6600',
    borderRadius: 12,
  },
  progressText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FF6600',
    minWidth: 45,
    textAlign: 'right',
  },
});
